import request from '@/axios'


export function getCourseWithTeacher (platform_customer_id, payload = null) {
  return request({
    url:`course/list/short/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function enrolledStudentList (platform_customer_id, payload) {
  return request({
    url:`course/student/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function setAttendanceApi (platform_customer_id, payload) {
  return request({
    url:`course/attendance/submit/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

// course/attendance/fetch/{customer_id} =>post

export function fetchSingleAttendanceHistoryApi (platform_customer_id, payload) {
  return request({
    
    url:`ClientUser/course/attendance/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getAttendanceDate (platform_customer_id, payload) {
  return request({
    url:`course/attendance_date/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getStudentList (platform_customer_id) {
  return request({
    url:`ClientUser/list/short/${platform_customer_id}`,
    method:'GET'
  })
}
